import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import AccountCreate from '@app/views/Account/Create';
import { memo } from 'react';

export default memo(
  withIfUser(AccountCreate)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
